// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3m2pU","col":"styles_col__3UzgY"};